import { useState, useEffect, useRef } from 'react';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const EditVAPModal = ({ id: propId, open, setOpen ,fetchData,type:typeProb}) => {
  const [id, setId] = useState(null);
  const [type,setType] = useState(null)
  const [loading, setLoading] = useState(true);
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (open && propId != null) {
      setId(propId);
    }
    if(open && typeProb != null)
    {
        setType(typeProb)
    }
  }, [open, propId,typeProb]);
  
  // Fetch existing resource
  useEffect(() => {
    if (!id) return;
     const endpoint =
      Number(type) === 2
        ? `${BASE_URL}/courses/${id}/video/resource/get/`
        : Number(type) === 3
        ? `${BASE_URL}/courses/${id}/audio/resource/get/`
        : Number(type) === 4
        ? `${BASE_URL}/courses/${id}/podcast/resource/get/`
        : "";

    if (!endpoint) return;
    const fetchResource = async () => {
      try {
        setLoading(true);
        const response = await fetch(endpoint,{
          headers: {
           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        });
        if (!response.ok) throw new Error('Failed to fetch resource');
        const data = await response.json();
        setFileName(data.file || '');
      } catch (error) {
        console.error('Failed to fetch resource', error);
        setFileName('');
      } finally {
        setLoading(false);
      }
    };

    fetchResource();
  }, [id]);

  // Drag & Drop handlers
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setFile(e.dataTransfer.files[0]);
      setFileName(e.dataTransfer.files[0].name);
      e.dataTransfer.clearData();
    }
  };

  const handleDragOver = (e) => e.preventDefault();
  const handleClose = () => setOpen(false);
   
  // Save handler
  const handleSave = async () => {
    if (!id) {
      alert('ID is required');
      return;
    }
    const endpoint =
    Number(type) === 2
        ? `${BASE_URL}/courses/${id}/video/resource/update/`
        : Number(type) === 3
        ? `${BASE_URL}/courses/${id}/audio/resource/update/`
        : Number(type) === 4
        ? `${BASE_URL}/courses/${id}/podcast/resource/update/`
        : "";

    if (!endpoint) return;
    setUpdateLoading(true);
    try {
      const formData = new FormData();
      if (file) formData.append('file', file);
      else formData.append('file', fileName);

      const response = await fetch(endpoint, {
        method: 'PUT',
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      if (!response.ok) throw new Error('Failed to save resource');

      alert(`${Number(type) === 2 ? 'Video' : Number(type) === 3 ? 'Audio' : 'Podcast'} resource updated successfully!`);
      setUpdateLoading(false);
      fetchData()
      handleClose();
    } catch (error) {
      console.error('Failed to save resource', error);
       alert(`Failed to update ${Number(type) === 2 ? 'Video' : Number(type) === 3 ? 'Audio' : 'Podcast'} resource`);
      setUpdateLoading(false);
    }
  };

  if (!open) return null;

  return (
 <div
  className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4"
  onClick={handleClose}
>
  <div
    className="bg-white rounded-2xl w-full max-w-lg shadow-xl"
    onClick={(e) => e.stopPropagation()}
  >
    {/* Header */}
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
          </svg>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Edit Resource</h2>
          <p className="text-sm text-gray-500 mt-0.5">Update your resource file</p>
        </div>
      </div>
    </div>

    {/* Content */}
    {loading ? (
      <div className="flex flex-col items-center justify-center py-12">
        <div className="w-8 h-8 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin mb-3"></div>
        <p className="text-sm text-gray-500">Loading...</p>
      </div>
    ) : (
      <>
        <div className="p-6 space-y-5">
          {fileName && (
            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-gray-500">Current Resource</p>
                <a
                  className="text-sm font-medium text-[#0f6abf] hover:underline"
                  href={fileName}
                  target="_blank"
                  rel="noreferrer"
                >
                  {fileName}
                </a>
              </div>
            </div>
          )}

          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">Upload New File</label>
            </div>
            
            <div
              className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center cursor-pointer hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-all"
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onClick={() => fileInputRef.current.click()}
            >
              <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
              </div>
              <p className="text-sm text-gray-700 font-medium mb-1">
                {file ? file.name : "Drag & drop a file here"}
              </p>
              <p className="text-xs text-gray-500">
                {file ? "" : "or click to select"}
              </p>
            </div>
          </div>
        </div>

        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          onChange={(e) => {
            if (e.target.files.length > 0) {
              setFile(e.target.files[0]);
              setFileName(e.target.files[0].name);
            }
          }}
        />

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
          <div className="flex items-center justify-end gap-3">
            <button
              className="px-4 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
              onClick={handleSave}
            >
              {updateLoading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Saving...
                </>
              ) : (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Save
                </>
              )}
            </button>
          </div>
        </div>
      </>
    )}
  </div>
</div>

  );
};

export default EditVAPModal;
